/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import './hardwareCost.scss';
import MagnifyingGlass from '../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import ButtonComponent from '../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '../../../Assets/images/svg/dar_pencil.svg';
import { TextField } from '@mui/material';
import { formatCurrency} from '../costMasterUtils';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import { getHardwareCost, getCloudCost, saveHardwareCost, updateHardwareCost } from '../../../Api/request/costMaster';
import UseAxios from '../../../Api/http/http';
import { v4 as uuidv4 } from 'uuid';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';

const HardwareCost = () => {
  const [hardwareCostRows, setHardwareCostRows] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isMobileView, setIsMobileView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { userProfile } = useContext(AuthContext);

  const permission = userProfile?.permissions?.[MODULE_NAMES.MASTER_COST_MASTER] ?? [];


  const hasAccess = (action) => {
    return permission.includes(action);
  };
  const [operationType, setOperationType] = useState('insert');
  const [currencies, setCurrencies] = useState([]);
  const [units, setUnits] = useState([]);
  const { snackbarOpen } = useSnackbar();

  useEffect(() => {
    checkMobileView();
    fetchDropdownData();
    fetchHardwareCostDetails();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [hardwareCostRows]);

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1024);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };
  const fetchDropdownData = async () => {
    try {
      const response = await UseAxios(getCloudCost());
      const { currencies, units } = response.data.data;
      setCurrencies(currencies);
      setUnits(units);
    } catch (error) {
      console.error('Error fetching dropdown data:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };
  const fetchHardwareCostDetails = async () => {
    try {
      const response = await UseAxios(getHardwareCost());
      const transformedData = response?.data?.data?.map((item, index) => ({
        id: item.id,
        srNo: index + 1,
        hardware: item.hardware,
        specification: item.specification,
        unit: item.unit,
        cost: item.cost,
        currency: item.currency,
        remarks: item.remarks,
        isEditing: false, 
      }));
  
      setHardwareCostRows(transformedData);
    } catch (error) {
      console.error('Error fetching cloud cost details:', error.message || error);
      snackbarOpen('Oops! Please try again', 'warning');
    }
  };

  const handleAddRow = () => {
    const defaultCurrency = 'USD';
    const defaultCurrencyId = getFieldIdValue('currency', defaultCurrency);
    const newRow = {
      id: uuidv4(),
      checkbox: false,
      srNo: 1,
      hardware: '',
      specification: '',
      cost: '',
      currency: defaultCurrency,
      currencyId: defaultCurrencyId,
      unit:'',
      remarks: '',
      isEditing: true,
      rowHeight: 120,
    };
    setHardwareCostRows((prevRows) => {
      const updatedRows = [newRow, ...prevRows].map((row, index) => ({
        ...row,
        srNo: index + 1,
      }));
      return updatedRows;
    });
    setOperationType('insert');
  };

  const getFieldIdValue = (field, value) => {
    switch (field) {
      case 'unit':
        return units.find((unit) => unit.name === value)?.id || null;
      case 'currency':
        return currencies.find((currency) => currency.name === value)?.id || null;
      default:
        return value;
    }
  };

  const handleInputChange = (e, id, field) => {
    const value = e.target.value?.name || e.target.value;
    setHardwareCostRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          const fieldIdValue = getFieldIdValue(field, value);
          return {
            ...row,
            [field]: value,
            [`${field}Id`]: fieldIdValue, 
          };
        }
        return row;
      })
    );
  };

  const handleSave = (id) => {
      const rowToSave = hardwareCostRows.find((row) => row.id === id);
      saveRow(rowToSave, operationType);
  };
  
  const saveRow = async (rowToSave, operationType) => {
    const id = rowToSave.id;

    const payload = {
      hardware: rowToSave.hardware,
      specification: rowToSave.specification,
      unit: rowToSave.unitId,
      cost: rowToSave.cost,
      currency: rowToSave.currencyId,
      remarks: rowToSave.remarks,
      is_active: 'true',
    };
    if (operationType === 'insert') {
      try {
        await UseAxios(saveHardwareCost(payload));
        snackbarOpen('Data saved successfully', 'success');
      } catch (error) {
        console.error('Error saving row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;
      }
    }
    else if (operationType === 'update') {
      try {
        payload.id = id;
        await UseAxios(updateHardwareCost(id, payload));
        snackbarOpen('Data updated successfully', 'success');
      } catch (error) {
        console.error('Error updating row:', error.message || error);
        snackbarOpen('Oops! Please try again', 'warning');
        return;
      }
    }
    setHardwareCostRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowToSave.id ? { ...row, isEditing: false } : row
      )
    );
    fetchHardwareCostDetails();
  }

  const handleCancel = (id) => {
    setHardwareCostRows((prevRows) =>
      prevRows.some((row) => row.isEdit)
        ? 
          prevRows.map((row) =>
            row.id === id
              ? { ...row.originalData, isEditing: false, isEdit: false }
              : row
          )
          .filter((row) => row.id)
          .map((row, index) => ({
           ...row,
           srNo: index + 1,
          }))
        : 
          prevRows
            .filter((row) => row.id !== id)
            .map((row, index) => ({
              ...row,
              srNo: index + 1, 
            }))
    );
  };

  const handleEdit = (id) => {
    setOperationType('update');
    setHardwareCostRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, isEditing: true, isEdit: true, originalData: { ...row } } : row))
    );
  };

  const getSelectedValue = (name, options) => {
    return options.find(option => option.name === name) || null;
  };

  const newHardwareRow = {
    hardware: '',
    cost: '',
    unit:'',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newHardwareRow).some((key) => row[key] === newHardwareRow[key]);
  };
 
  const columns = [
    {
      field: 'srNo',
      headerName: 'Sr.No.',
      width: isMobileView ? 90 : undefined,
      flex: !isMobileView ? 0.2 : undefined,
      minWidth: 145,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'hardware',
      headerName: 'Hardware',
      width: isMobileView ? 220 : undefined,
      flex: !isMobileView ? 0.6 : undefined,
      minWidth: 165,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              defaultValue={row.hardware}
              onChange={(e) => handleInputChange(e, row.id, "hardware")}
              onKeyDown={(e) => e.stopPropagation()}
              className='text-box-css input'
              variant="outlined"
              size="small"
            />
          </div>
        ) : (
          <label className="saved-value">{row.hardware}</label>
        ),
      
    },
    {
      field: 'specification',
      headerName: 'Specification',
      width: isMobileView ? 240 : undefined,
      flex: !isMobileView ? 0.8 : undefined,
      minWidth: 180,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
              defaultValue={row.specification}
              onChange={(e) => handleInputChange(e, row.id, "specification")}
              onKeyDown={(e) => e.stopPropagation()}
              className='text-box-css input'
              variant="outlined"
              size="small"
            />
        ) : (
          <label className="saved-value">{row.specification && row.specification.trim() !== ''
            ? row.specification
            : '-'}
          </label>
        ),
    },

    {
      field: 'cost',
      headerName: 'Cost',
      width: isMobileView ? 200 : undefined,
      flex: !isMobileView ? 0.7 : undefined,
      minWidth: 80,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: 'cost-header',
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', alignItems: 'center'}} className="number-input-div">
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={currencies}
              onChange={(e) => handleInputChange(e, row.id, 'currency')}
              value={getSelectedValue(row.currency, currencies)}
              dropdownCss="currency-select"
            />  
            <TextField
              defaultValue={row.cost}
              onChange={(e) => handleInputChange(e, row.id, "cost")}
              onKeyDown={(e) => e.stopPropagation()}
              className="number-input"
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*[.]?[0-9]*',
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                const parts = e.target.value.split('.');
                if (parts.length > 2) {
                  e.target.value = parts[0] + '.' + parts.slice(1).join('');
                }
              }}
            />
          </div>
        ) : (
          <label className="saved-value cost-cell">
            {formatCurrency(row.cost, row.currency)}
          </label>
        ),
    },
    {
      field: 'unit',
      headerName: 'Unit',
      width: isMobileView ? 200 : undefined,
      flex: !isMobileView ? 0.7 : undefined,
      minWidth: 150,
      sortable: false,
      disableColumnMenu: true,

      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={units}
              onChange={(e) => handleInputChange(e, row.id, 'unit')}
              value={getSelectedValue(row.unit, units)}
              dropdownCss="text-box-css"
            />
          </div>
        ) : (
          <label className="saved-value">{row.unit}</label>
        ),
    },

    {
      field: 'remarks',
      headerName: 'Remarks',
      width: isMobileView ? 300 : undefined,
      flex: !isMobileView ? 1 : undefined,
      minWidth: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <TextField
              defaultValue={row.remarks}
              onChange={(e) => handleInputChange(e, row.id, "remarks")}
              onKeyDown={(e) => e.stopPropagation()}
              className="text-box-css input"
              variant="outlined"
              size="small"
            />
        ) : (
          <label className="saved-value">{row.remarks && row.remarks.trim() !== ''
            ? row.remarks
            : '-'}</label>
        ),
    },

    {
      width: isMobileView ? 60 : undefined,
      flex: !isMobileView ? 0.25 : undefined,
      minWidth: 60,
      headerClassName: 'action-column',
      cellClassName: 'action-cell',
      renderCell: ({row}) => (
        <div className="mobile-action-icons">
        {!row?.isEditing ? (        
          <button
            className="role-action-edit-icon"
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
              opacity: hasAccess('update') ? 1 : 0.5, 
            }}
            onClick={() => handleEdit(row.id)}
            disabled={!hasAccess('update')}

          >
            <img src={EditIcon} alt="Edit" />
          </button>
        ):(
        <div className='save-and-cancel-button-main' style={{ paddingTop: isMobileView ? '0px' : '4px' }}>
          <button
            className='save-and-cancel-button save-button-tick-placing'
            style={{
              backgroundColor: isRowUnchanged(row) ? '#a69df1' : '#6B5CE8', 
              color: '#ffff',
            }}
            disabled={isRowUnchanged(row)}
            onClick={() => handleSave(row.id)}
          >✔</button>
          <button
            className='save-and-cancel-button save-button-cross-placing'
            style={{
              backgroundColor: 'transparent',
              color: '#6B5CE8',
              border: '1px solid #6B5CE8'
            }}
            onClick={() => handleCancel(row.id)}
          >X</button>
        </div>
      )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const filteredRows = searchText
    ? hardwareCostRows.filter((row) =>
        Object.values(row).some((value) =>
          (value ? value.toString() : '').toLowerCase().includes(searchText)
        )
      )
    : hardwareCostRows;

  const sortFilterColumns = [
    columns[0].field,
    columns[1].field,
    columns[2].field,
    columns[3].field,
    columns[4].field,
    columns[5].field,
  ];
  const rowHeightCondition = (params) => {
    const row = hardwareCostRows.find((row) => row.id === params.id);
    const isOtherSelected = row?.isEditing && (row?.Hardware === 'Other' || row?.unit === 'Other');
  
    if (isOtherSelected) {
      return 150;
    } else if (row?.isEditing) {
      return 104;
    } else {
      return 52;
    }
  };
  
  
  return (
    <div className="cloud-cost-outer-layer">
      <div className="cloud-cost-map">
        <div
          className="cloud-cost-search-and-buttons"
          style={{ marginBottom: '20px' }}
        >
          <div className="cloud-cost-search">
            <img src={MagnifyingGlass} alt="Search" />
            <input
              id="cloud-cost-search-input"
              type="text"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="hardware-cost-container">
          <div className="hardware-cost-header">
          <div className="hardware-cost-title">Hardware Cost</div>
          <div className="cloud-cost-buttons">
            <div className="cloud-cost-filter-and-add-button">
              <ButtonComponent
                variant="contained"
                label="Add"
                onClick={handleAddRow}
                startIcon={<AddIcon />}
                disabled={!hasAccess('create')}

              />
            </div>
          </div>
          </div>
          <div className="data-grid-container">
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={columns}
              isDealTransition={true}
              pageSize={10}
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              isEdit={isEdit}
              gridCheckbox={false}
              onRowSelectionChange={() => {}}
              dataGridCss=""
              checkboxDisabled={false}
              rowHeightCondition={rowHeightCondition}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default HardwareCost;
